var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 26.661,
    viewBox: "778 692.003 30 26.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m798.969 696.332 4.698 4.698a.51.51 0 0 1 0 .718l-11.375 11.375-4.834.537a1.013 1.013 0 0 1-1.12-1.12l.537-4.833 11.375-11.375a.51.51 0 0 1 .719 0Zm8.437-1.193-2.541-2.542a2.037 2.037 0 0 0-2.875 0l-1.844 1.844a.51.51 0 0 0 0 .719l4.698 4.698a.51.51 0 0 0 .719 0l1.843-1.844a2.037 2.037 0 0 0 0-2.875ZM798 710.029v5.303h-16.667v-16.667h11.97a.64.64 0 0 0 .442-.182l2.083-2.084a.625.625 0 0 0-.442-1.067H780.5a2.5 2.5 0 0 0-2.5 2.5v18.333a2.5 2.5 0 0 0 2.5 2.5h18.333a2.5 2.5 0 0 0 2.5-2.5v-8.219a.626.626 0 0 0-1.067-.443l-2.084 2.084a.64.64 0 0 0-.182.443Z",
    fill: "#4a5264",
    fillRule: "evenodd",
    "data-name": "Icon awesome-edit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLogo);
export default __webpack_public_path__ + "static/media/EditLogo.aaf2c7513427f8c787d5d468f1555b71.svg";
export { ForwardRef as ReactComponent };